export default __webpack_public_path__ + "static/logo_color-83d962d94dda8ad17c067a6088b53bcd.webp";